import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconV2CalendarOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="1em" height="1em"><path d="M6 26V12h20v12h2V4h-5V2h-2v2H11V2H9v2H4v24h22.6l1.4-2zM9 6v2h2V6h10v2h2V6h3v4H6V6z" /></svg>
);
